module.exports = __webpack_public_path__ + "static/media/Profile_pic.154594ed.png";